import { Injector } from '@angular/core';
import { CrudVariable } from '@wavemaker/variables';
import { WmsCrudVariableService } from '@wms/variables';

export class WmsCrudVariable extends CrudVariable {
  crudVariableService: WmsCrudVariableService;

  constructor(variable: any, private injector: Injector) {
    super(variable);
    this.crudVariableService = this.injector.get(WmsCrudVariableService);
  }


  __getVariableDependencies() {
    return this.crudVariableService.__getVariableDependencies();
  }

  __onPropertyChange(propertyName: string, value?: any, initFlag?: any) {
    return this.crudVariableService.__onPropertyChange(propertyName, value, initFlag);
  }

  __setServiceOperations(operations: any, selectedVariable: any, initFlag: any, serviceType: any) {
    return this.crudVariableService.__setServiceOperations(operations, selectedVariable, initFlag, serviceType);
  }

  __updateCrudService(key: any) {
    return this.crudVariableService.__updateCrudService(key);
  }

  __prepareBindingObjectList(param: any, variable: any, oldBindings: any, operation: any) {
    return this.crudVariableService.__prepareBindingObjectList(param, variable, oldBindings, operation);
  }
}
